const getInputElement = (el: HTMLElement) => {
  if (el instanceof HTMLDivElement) {
    const component = el.querySelector('input, textarea')
    if (component instanceof HTMLInputElement || component instanceof HTMLTextAreaElement) {
      return component
    }
  }
  return el
}

const onFocusHandler = (event: FocusEvent) => {
  if (event.target instanceof HTMLInputElement || event.target instanceof HTMLTextAreaElement) {
    event.target.select()
  }
}

/**
 * Adds focus event listener to component to select the text when focused.
 */
export default {
  mounted (el: HTMLElement) {
    const component = getInputElement(el)
    component.addEventListener('click', onFocusHandler)
  },
  beforeUnmount (el: HTMLElement) {
    const component = getInputElement(el)
    component.removeEventListener('click', onFocusHandler)
  },
}
